export default __webpack_public_path__ + "static/media/10.7663d9d0.gif";